import { AppDispatch, RootState } from '@src/store/store'

import { setIsInitialized } from '@src/store/ducks/app/reducer'
import { setIsAuth } from '@src/store/ducks/auth/reducer'
import { userApi } from '@src/api/user-api'
import { setUser } from '@src/store/ducks/user/reducer'
import { contactApi } from '@src/api/contact-api'
import { selectUserCurrentAddresses, selectUserInfo, selectUserServices } from '@src/store/ducks/user/selectors'
import {
  setIsLoadingCallBack, setIsLoadingTariffRequest, setIsSuccessCallBack, setIsSuccessTariffRequest,
} from '@src/store/ducks/contacts/reducer'
import { Store } from 'react-notifications-component'
import { isString } from '@src/lib/utils'
import { errors } from '@src/messages/errors'

export const fetchMe = () => async (dispatch: AppDispatch) => {
  try {
    const result = await userApi.getMe()
    dispatch(setUser(result))
    dispatch(setIsAuth(true))
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status === 401) {
      dispatch(setIsAuth(false))
    }
  } finally {
    dispatch(setIsInitialized())
  }
}

export const callBack = (name: string, phone: string) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingCallBack(true))
    const currentAddresses = selectUserCurrentAddresses(getState())
    await contactApi.callBack(name, phone, currentAddresses?.account)
    dispatch(setIsSuccessCallBack(true))
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingCallBack(false))
  }
}

export const tariffRequest = (
  phone: string, tariffName: string,
) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingTariffRequest(true))
    const { tariff } = selectUserServices(getState())
    const userInfo = selectUserInfo(getState())
    if (tariff.length) {
      await contactApi.tariffRequest(userInfo.username, phone, tariff[0].address, tariffName)
      dispatch(setIsSuccessTariffRequest(true))
    }
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingTariffRequest(false))
  }
}
